export default __webpack_public_path__ + "static/media/eb-pro-blk-4.be00edf1.png";